import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import AppBar from '@material-ui/core/AppBar';
import Slide from '@material-ui/core/Slide';
import Header from './components/Header';

const useStyles = makeStyles((theme) => ({
	appBar: {
		//padding: '10px 5px',
		background: 'transparent',
		boxShadow: 'none',
		backgroundColor: theme.palette.main,
	},
	appBarScroll: {
		//backgroundColor: theme.palette.common.white,
	},
}));

function ShowOnScroll(props) {
	const { children, trigger } = props;

	return (
		<Slide appear={false} direction='down' in={trigger}>
			{children}
		</Slide>
	);
}

ShowOnScroll.propTypes = {
	children: PropTypes.node.isRequired,
	trigger: PropTypes.bool,
};

const AppHeader = (props) => {
	const classes = useStyles();
	const trigger = useScrollTrigger({ threshold: 300 });
	return (
		<React.Fragment>
			<AppBar position='static' color='primary' className={classes.appBar}>
				<Header title={props.title} />
			</AppBar>
			{props.showOnScroll && (
				<ShowOnScroll trigger={trigger}>
					<AppBar color='primary' className={[classes.appBar, classes.appBarScroll].join(' ')}>
						<Header title={props.title} />
					</AppBar>
				</ShowOnScroll>
			)}
		</React.Fragment>
	);
};

AppHeader.propTypes = {
	showOnScroll: PropTypes.bool,
	title: PropTypes.string.isRequired,
	//onProtfolioChange: PropTypes.func,
	//onEffectiveDateChange: PropTypes.func
};

export default AppHeader;
